import { Component, Input } from '@angular/core';
import { OuiTagBrand, OuiTagSize, OuiTagStatus } from 'omnium-ui/tag';
import { FicheConseilState } from 'projects/fiche-conseil-lib/src/public-api';

type TagType = 'status' | 'brand';
type Declination = 'primary' | 'secondary';
type TagKey = 'draft' | 'done';
type StatutTagConfig = {
  key: TagKey;
  label: string;
  tagType: TagType;
  value: OuiTagBrand | OuiTagStatus;
  declination: Declination;
};
@Component({
  selector: 'lib-fiche-conseil-statut-tag',
  templateUrl: './fiche-conseil-statut-tag.component.html',
  styleUrls: ['./fiche-conseil-statut-tag.component.scss'],
})
export class FicheConseilStatutTagComponent {
  allConfigs: StatutTagConfig[] = [
    {
      key: 'draft',
      label: 'Brouillon',
      tagType: 'status',
      value: 'todo',
      declination: 'primary',
    },
    {
      key: 'done',
      label: 'Terminé',
      tagType: 'status',
      value: 'completed',
      declination: 'primary',
    },
  ];
  config: StatutTagConfig;
  brandValue: OuiTagBrand | undefined;
  statusValue: OuiTagStatus | undefined;

  @Input({ required: true }) set statut(statut: FicheConseilState) {
    this.config = this.allConfigs.find(c => c.key === this.getStatusKey(statut)) ?? this.allConfigs[0];

    if (this.config.tagType === 'brand') {
      this.brandValue = this.config.value as OuiTagBrand;
    } else if (this.config.tagType === 'status') {
      this.statusValue = this.config.value as OuiTagStatus;
    }
  }
  getStatusKey(statut: FicheConseilState) {
    if (statut === FicheConseilState.ConseilDone) return 'done';
    return 'draft';
  }
  @Input() size: OuiTagSize = 'big';
  constructor() {}
}
